<template>
  <div class="costcases-container">
    <!-- 轮播图区域 -->
    <div class="banner-section">
      <div class="banner-container">
        <div
          v-for="(slide, index) in bannerSlides"
          :key="index"
          class="banner-slide"
          :class="{ active: currentSlide === index }"
        >
          <img :src="slide.image" :alt="slide.alt" class="banner-image">
        </div>

        <!-- 轮播图指示器 -->
        <div class="banner-indicators">
          <span
            v-for="(slide, index) in bannerSlides"
            :key="index"
            class="indicator"
            :class="{ active: currentSlide === index }"
            @click="goToSlide(index)"
          />
        </div>

        <!-- 左右切换按钮 -->
        <div class="banner-nav prev" @click="prevSlide">
          <i class="el-icon-arrow-left" />
        </div>
        <div class="banner-nav next" @click="nextSlide">
          <i class="el-icon-arrow-right" />
        </div>
      </div>
    </div>

    <!-- 选择市：轮播图下方，与下方主内容区同宽对齐 -->
    <div class="region-city-under-banner">
      <region-city-picker />
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 页面标题 -->
      <div class="page-header">
        <img src="@/assets/image/al/icon.png" alt="" class="page-title-icon">
        <div class="page-title">建设工程分类</div>
      </div>

      <div class="content-layout">
        <!-- 左侧分类 + 二三级下拉 -->
        <div class="sidebar-group">
          <div class="sidebar">
            <div class="category-list">
              <div
                v-for="category in categories"
                :key="category.value"
                class="category-item"
                :class="{ active: selectedCategory === category.value }"
                @click="selectCategory(category.value)"
              >
                <span
                  class="category-icon-slot"
                  :class="{ 'is-empty': !getCategoryIconUrl(category) }"
                >
                  <img
                    v-if="getCategoryIconUrl(category)"
                    :src="getCategoryIconUrl(category)"
                    :alt="category.label"
                    class="category-icon"
                  >
                </span>
                <span class="category-label">{{ category.label }}</span>
              </div>
            </div>
          </div>

          <!-- 分类下拉选择（仅二、三级，一级已在左侧 sidebar 展示） -->
          <div
            v-if="showCategoryDropdown && currentSubCategories.length > 0"
            class="category-dropdown"
          >
            <div class="dropdown-content">
              <!-- 二级分类 -->
              <div class="subcategory-content">
                <div class="subcategory-list">
                  <div
                    v-for="subCategory in currentSubCategories"
                    :key="subCategory.value"
                    class="subcategory-item"
                    :class="{ active: selectedSubCategory === subCategory.value }"
                    @click="selectSubCategory(subCategory.value)"
                  >
                    {{ subCategory.label }}
                  </div>
                </div>
              </div>

              <!-- 三级分类 -->
              <div v-if="selectedSubCategory && currentSubSubCategories.length > 0" class="subsubcategory-content">
                <div class="subsubcategory-list">
                  <div
                    v-for="subSubCategory in currentSubSubCategories"
                    :key="subSubCategory.value"
                    class="subsubcategory-item"
                    :class="{ active: selectedSubSubCategory === subSubCategory.value }"
                    @click="selectSubSubCategory(subSubCategory.value)"
                  >
                    {{ subSubCategory.label }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧内容区域 -->
        <div class="right-content">
          <!-- 搜索区域 -->
          <div class="search-section">
            <div class="search-input">
              <img
                src="@/assets/image/search1.png"
                alt="搜索"
                class="search-icon"
              >
              <input
                v-model="searchKeyword"
                type="text"
                placeholder="请输入材料名称、规格型号或品牌搜索"
                @keyup.enter="handleSearch"
              >
            </div>
            <button class="search-btn" @click="handleSearch">搜索</button>
          </div>

          <!-- 推荐案例 -->
          <div class="recommended-section">
            <div class="section-title">推荐案例</div>
            <div v-if="loading" class="loading-text">加载中...</div>
            <div v-else-if="recommendedCases.length === 0" class="no-data">暂无推荐案例</div>
            <div v-else class="recommended-single" @mouseenter="stopRecommendAutoPlay" @mouseleave="startRecommendAutoPlay">
              <div v-for="(item, idx) in recommendedCases" v-show="idx === currentRecommendIndex" :key="item.id" class="recommended-slide" @click="viewCaseDetail(item)">
                <img :src="$getImageUrl(item.cover_image || item.image)" :alt="item.title" class="recommended-image">
                <div class="recommended-title">{{ item.title }}</div>
              </div>

              <div class="banner-indicators">
                <span
                  v-for="(item, idx) in recommendedCases"
                  :key="idx"
                  class="indicator"
                  :class="{ active: currentRecommendIndex === idx }"
                  @click="goToRecommend(idx)"
                />
              </div>

              <div class="banner-nav prev" @click="prevRecommend">
                <i class="el-icon-arrow-left" />
              </div>
              <div class="banner-nav next" @click="nextRecommend">
                <i class="el-icon-arrow-right" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 工业建筑 -->
    <div class="industrial-cases-section">
      <div v-if="industrialLoading" class="list-loading">加载中...</div>
      <div v-else-if="industrialCases.length === 0" class="list-empty">
        <img src="@/assets/image/al/icon.png" alt="" class="list-empty-icon">
        <div class="list-empty-text">暂无案例数据</div>
      </div>
      <div v-else class="cases-grid">
        <div
          v-for="caseItem in industrialCases"
          :key="caseItem.id"
          class="case-card"
          @click="viewCaseDetail(caseItem)"
        >
          <div class="case-image">
            <img
              :src="$getImageUrl(caseItem.image || caseItem.cover_image)"
              :alt="caseItem.title"
              class="case-img"
            >
          </div>
          <div class="case-title">{{ caseItem.title }}</div>
        </div>
      </div>
      <div v-if="!industrialLoading && industrialTotal > 0" class="industrial-pagination-wrap">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="industrialPage"
          :page-size="industrialLimit"
          :page-sizes="industrialPageSizes"
          :total="industrialTotal"
          class="industrial-pagination"
          @current-change="handleIndustrialPageChange"
          @size-change="handleIndustrialSizeChange"
        />
      </div>
    </div>
  </div></template>

<script>
import { getCostCaseCategory } from '@/api/user'
import { getRecommendCostCase, getCostCase } from '@/api/costcase'
import RegionCityPicker from '@/components/RegionCityPicker.vue'

export default {
  name: 'Costcases',
  components: { RegionCityPicker },
  data() {
    return {
      searchKeyword: '',
      selectedCategory: '',
      currentSlide: 0, // 当前轮播图索引
      bannerSlides: [
        { image: require('@/assets/image/al/lb1.png'), alt: '轮播图' },
        { image: require('@/assets/image/bg1.png'), alt: '轮播图' },
        { image: require('@/assets/image/bg2.png'), alt: '轮播图' }
      ],
      categories: [], // 通过API获取分类数据
      categoryData: {
        civil: {
          label: '民用建筑',
          subCategories: [
            {
              label: '居住建筑',
              value: 'residential',
              subSubCategories: [
                { label: '商品住宅', value: 'commercial_housing' },
                { label: '政府保障住宅', value: 'government_housing' },
                { label: '公寓住宅', value: 'apartment' },
                { label: '别墅', value: 'villa' },
                { label: '其他居住建筑', value: 'other_residential' }
              ]
            },
            {
              label: '旅游相关工程',
              value: 'tourism',
              subSubCategories: []
            },
            {
              label: '办公建筑',
              value: 'office',
              subSubCategories: []
            },
            {
              label: '其他公共配套',
              value: 'public_facilities',
              subSubCategories: []
            },
            {
              label: '酒店建筑',
              value: 'hotel',
              subSubCategories: []
            },
            {
              label: '地下建筑工程',
              value: 'underground',
              subSubCategories: []
            },
            {
              label: '商业建筑',
              value: 'commercial',
              subSubCategories: []
            },
            {
              label: '人防建筑',
              value: 'civil_defense',
              subSubCategories: []
            },
            {
              label: '医疗建筑',
              value: 'medical',
              subSubCategories: []
            },
            {
              label: '建筑改建',
              value: 'renovation',
              subSubCategories: []
            },
            {
              label: '教育建筑',
              value: 'education',
              subSubCategories: []
            },
            {
              label: '装修工程',
              value: 'decoration',
              subSubCategories: []
            },
            {
              label: '交通建筑',
              value: 'transportation',
              subSubCategories: []
            },
            {
              label: '文体建筑',
              value: 'cultural_sports',
              subSubCategories: []
            },
            {
              label: '仿古建筑',
              value: 'ancient_style',
              subSubCategories: []
            },
            {
              label: '科研实验',
              value: 'research',
              subSubCategories: []
            }
          ]
        }
      },
      showCategoryDropdown: false,
      selectedSubCategory: '',
      selectedSubSubCategory: '',
      recommendedCases: [], // 推荐案例列表
      loading: false, // 加载状态
      industrialCases: [],
      industrialLoading: false,
      currentRecommendIndex: 0,
      recommendTimer: null,
      industrialPage: 1,
      industrialLimit: 8,
      industrialTotal: 0,
      industrialPageSizes: [8, 16, 24],
      industrialFetchSeq: 0
    }
  },
  computed: {
    currentSubCategories() {
      if (this.selectedCategory) {
        const category = this.categories.find(cat => cat.value === this.selectedCategory)
        if (category && category.children) {
          return category.children.map(child => ({
            id: child.id,
            label: child.title,
            value: this.generateCategoryValue(child.title),
            icon: child.icon || '',
            children: child.children || [],
            has_children: child.has_children || false
          }))
        }
      }
      return []
    },

    currentSubSubCategories() {
      if (this.selectedSubCategory && this.currentSubCategories.length > 0) {
        const subCategory = this.currentSubCategories.find(item => item.value === this.selectedSubCategory)
        if (subCategory && subCategory.children) {
          return subCategory.children.map(child => ({
            id: child.id,
            label: child.title,
            value: this.generateCategoryValue(child.title),
            icon: child.icon || '',
            children: child.children || [],
            has_children: child.has_children || false
          }))
        }
      }
      return []
    }
  },
  watch: {
    '$route.query.keyword'() {
      this.applyRouteKeyword(true)
    }
  },
  created() {
    this.applyRouteKeyword()
    this.initPageData()
    this.startRecommendAutoPlay()
  },
  mounted() {
    this.startAutoPlay()
    // 添加点击外部关闭下拉框的事件监听
    document.addEventListener('click', this.handleClickOutside)
    window.addEventListener('region-changed', this.handleRegionChanged)
  },
  beforeDestroy() {
    this.stopAutoPlay()
    this.stopRecommendAutoPlay()
    // 移除事件监听
    document.removeEventListener('click', this.handleClickOutside)
    window.removeEventListener('region-changed', this.handleRegionChanged)
  },
  methods: {
    async initPageData() {
      await this.fetchCategories()
      await this.loadCaseData()
    },
    async loadCaseData() {
      this.industrialPage = 1
      await Promise.all([
        this.fetchRecommendCases(),
        this.fetchIndustrialCases()
      ])
    },
    extractCaseList(data) {
      if (!data) return []
      if (Array.isArray(data)) return data
      if (Array.isArray(data.list)) return data.list
      return []
    },
    mapCategoryList(rawList) {
      if (!Array.isArray(rawList)) return []
      return rawList.map(item => ({
        id: item.id,
        label: item.title,
        value: this.generateCategoryValue(item.title),
        icon: item.icon || '',
        children: item.children || [],
        has_children: item.has_children || false
      }))
    },
    applyRouteKeyword(refetch = false) {
      const keyword = (this.$route.query.keyword || '').trim()
      const changed = keyword !== this.searchKeyword
      this.searchKeyword = keyword
      if (refetch && changed) {
        this.loadCaseData()
      }
    },
    handleRegionChanged() {
      this.industrialPage = 1
      this.loadCaseData()
    },
    // 统一获取当前选择对应的分类ID（优先三级，其次二级；一级有子分类时不传）
    getSelectedCategoryId() {
      if (this.selectedSubSubCategory && this.currentSubSubCategories.length > 0) {
        const found = this.currentSubSubCategories.find(item => item.value === this.selectedSubSubCategory)
        return found ? found.id : undefined
      }
      if (this.selectedSubCategory && this.currentSubCategories.length > 0) {
        const found = this.currentSubCategories.find(item => item.value === this.selectedSubCategory)
        return found ? found.id : undefined
      }
      if (this.selectedCategory && this.categories.length > 0) {
        const category = this.categories.find(item => item.value === this.selectedCategory)
        if (!category) return undefined
        const hasChildren = category.has_children || (category.children && category.children.length > 0)
        return hasChildren ? undefined : category.id
      }
      return undefined
    },
    buildCaseQueryParams() {
      const params = {}
      const keyword = (this.searchKeyword || '').trim()
      if (keyword) {
        params.keyword = keyword
      }
      const categoryId = this.getSelectedCategoryId()
      if (categoryId !== undefined && categoryId !== null && categoryId !== '') {
        params.category_id = categoryId
      }
      return params
    },
    // 工业建筑案例获取
    async fetchIndustrialCases() {
      const seq = ++this.industrialFetchSeq
      try {
        this.industrialLoading = true
        const params = {
          ...this.buildCaseQueryParams(),
          page: this.industrialPage,
          limit: this.industrialLimit
        }
        const response = await getCostCase(params)
        if (seq !== this.industrialFetchSeq) return

        const data = response && response.data
        const list = this.extractCaseList(data)

        this.industrialCases = list.map(item => ({
          id: item.id,
          title: item.title,
          image: item.cover_image ? this.$getImageUrl(item.cover_image) : ''
        }))

        if (data && data.pagination && typeof data.pagination.total === 'number') {
          this.industrialTotal = data.pagination.total
        } else if (data && typeof data.total === 'number') {
          this.industrialTotal = data.total
        }

        const maxPage = Math.max(1, Math.ceil(this.industrialTotal / this.industrialLimit) || 1)
        if (this.industrialPage > maxPage) {
          this.industrialPage = maxPage
          await this.fetchIndustrialCases()
        }
      } catch (e) {
        if (seq !== this.industrialFetchSeq) return
        console.error('获取工业建筑案例失败:', e)
        this.industrialCases = []
      } finally {
        if (seq === this.industrialFetchSeq) {
          this.industrialLoading = false
        }
      }
    },
    // 推荐案例轮播控制
    startRecommendAutoPlay() {
      this.stopRecommendAutoPlay()
      if (!this.recommendedCases || this.recommendedCases.length <= 1) return
      this.recommendTimer = setInterval(() => {
        this.nextRecommend()
      }, 5000)
    },
    stopRecommendAutoPlay() {
      if (this.recommendTimer) {
        clearInterval(this.recommendTimer)
        this.recommendTimer = null
      }
    },
    nextRecommend() {
      if (!this.recommendedCases || this.recommendedCases.length === 0) return
      this.currentRecommendIndex = (this.currentRecommendIndex + 1) % this.recommendedCases.length
    },
    prevRecommend() {
      if (!this.recommendedCases || this.recommendedCases.length === 0) return
      this.currentRecommendIndex = (this.currentRecommendIndex - 1 + this.recommendedCases.length) % this.recommendedCases.length
    },
    goToRecommend(idx) {
      this.currentRecommendIndex = idx
      this.startRecommendAutoPlay()
    },
    // 获取推荐案例数据
    async fetchRecommendCases() {
      try {
        this.loading = true
        const params = {
          ...this.buildCaseQueryParams(),
          page: 1,
          limit: 1000
        }

        const response = await getRecommendCostCase(params)
        this.recommendedCases = this.extractCaseList(response && response.data)
        this.currentRecommendIndex = 0
        this.$nextTick(() => this.startRecommendAutoPlay())
      } catch (error) {
        console.error('获取推荐案例失败:', error)
        this.recommendedCases = []
      } finally {
        this.loading = false
      }
    },
    // 获取分类数据
    async fetchCategories() {
      try {
        const response = await getCostCaseCategory()
        if (response && response.data) {
          const rawList = Array.isArray(response.data)
            ? response.data
            : (response.data.list || response.data.categories || [])
          this.categories = this.mapCategoryList(rawList)
        }
      } catch (error) {
        console.error('获取分类数据失败:', error)
        this.categories = this.mapCategoryList([
          { id: 1, title: '民用建筑', children: [], has_children: false },
          { id: 2, title: '市政工程', children: [], has_children: false },
          { id: 3, title: '道路工程', children: [], has_children: false },
          { id: 4, title: '轨道交通', children: [], has_children: false },
          { id: 5, title: '桥涵工程', children: [], has_children: false },
          { id: 6, title: '隧道工程', children: [], has_children: false },
          { id: 7, title: '水工工程', children: [], has_children: false },
          { id: 8, title: '电力工程', children: [], has_children: false },
          { id: 9, title: '通信土建', children: [], has_children: false },
          { id: 10, title: '工业建筑', children: [], has_children: false }
        ])
      }
    },
    // 根据分类标题生成value值
    generateCategoryValue(title) {
      const valueMap = {
        '民用建筑': 'civil',
        '市政工程': 'municipal',
        '道路工程': 'road',
        '轨道交通': 'rail',
        '桥涵工程': 'bridge',
        '隧道工程': 'tunnel',
        '水工工程': 'hydraulic',
        '电力工程': 'power',
        '通信土建': 'communication',
        '工业建筑': 'industrial'
      }
      return valueMap[title] || title.toLowerCase().replace(/\s+/g, '_')
    },
    resolveCategoryIcon(icon) {
      const raw = (icon || '').trim()
      if (!raw) return null
      // 仅域名/端口、无实际图片路径时视为无效
      if (/^https?:\/\/[^/?#]+(?::\d+)?\/?$/i.test(raw)) return null
      if (/^https?:\/\//i.test(raw)) return raw
      return this.$getImageUrl(raw)
    },
    getCategoryIconUrl(category) {
      if (!category) return null
      return this.resolveCategoryIcon(category.icon)
    },
    selectCategory(categoryValue) {
      this.selectedCategory = categoryValue
      this.selectedSubCategory = ''
      this.selectedSubSubCategory = ''
      this.showCategoryDropdown = false
      this.$nextTick(() => {
        this.showCategoryDropdown = this.currentSubCategories.length > 0
      })
      // 选择分类后获取推荐案例
      this.fetchRecommendCases()
      this.industrialPage = 1
      this.fetchIndustrialCases()
    },
    selectSubCategory(subCategoryValue) {
      this.selectedSubCategory = subCategoryValue
      this.selectedSubSubCategory = ''
      // 选择子分类后获取推荐案例
      this.fetchRecommendCases()
      this.industrialPage = 1
      this.fetchIndustrialCases()
    },
    selectSubSubCategory(subSubCategoryValue) {
      this.selectedSubSubCategory = subSubCategoryValue
      // 选择三级分类后获取推荐案例
      this.fetchRecommendCases()
      this.industrialPage = 1
      this.fetchIndustrialCases()
    },
    handleIndustrialPageChange(page) {
      if (page === this.industrialPage) return
      this.industrialPage = page
      this.fetchIndustrialCases()
    },
    handleIndustrialSizeChange(size) {
      this.industrialLimit = size
      this.industrialPage = 1
      this.fetchIndustrialCases()
    },
    goToCaseList() {
      // 跳转到案例列表页面，传递选择的分类信息
      this.$router.push({
        path: '/costcases/caseList',
        query: {
          category: this.selectedCategory,
          subCategory: this.selectedSubCategory,
          subSubCategory: this.selectedSubSubCategory
        }
      })
    },
    handleClickOutside(event) {
      const dropdown = this.$el.querySelector('.category-dropdown')
      const sidebarGroup = this.$el.querySelector('.sidebar-group')

      if (dropdown && sidebarGroup && !dropdown.contains(event.target) && !sidebarGroup.contains(event.target)) {
        this.showCategoryDropdown = false
      }
    },
    getCurrentCategoryLabel() {
      const category = this.categories.find(cat => cat.value === this.selectedCategory)
      return category ? category.label : '案例'
    },
    handleSearch() {
      this.loadCaseData()
    },
    viewCaseDetail(caseItem) {
      this.$router.push({
        path: '/costcases/caseDetail',
        query: { id: caseItem.id }
      })
    },
    // 轮播图方法
    goToSlide(index) {
      this.currentSlide = index
    },
    prevSlide() {
      this.currentSlide = this.currentSlide > 0 ? this.currentSlide - 1 : this.bannerSlides.length - 1
    },
    nextSlide() {
      this.currentSlide = this.currentSlide < this.bannerSlides.length - 1 ? this.currentSlide + 1 : 0
    },
    startAutoPlay() {
      this.autoPlayTimer = setInterval(() => {
        this.nextSlide()
      }, 5000) // 5秒自动切换
    },
    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.costcases-container {
  min-height: 100vh;
  width: 100%;
  background: #f5f5f5;
  padding: 0;
  box-sizing: border-box;
}

// 轮播图样式
.banner-section {
  width: 100%;
  height: 400px;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;

  .banner-container {
    position: relative;
    width: 100%;
    height: 100%;

    .banner-slide {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: opacity 0.5s ease-in-out;

      &.active {
        opacity: 1;
      }

      .banner-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .banner-indicators {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 8px;

      .indicator {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.5);
        cursor: pointer;
        transition: all 0.3s ease;

        &.active {
          background: #0f6fe2;
        }

        &:hover {
          background: rgba(255, 255, 255, 0.8);
        }
      }
    }

    .banner-nav {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 40px;
      height: 40px;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 50%;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(0, 0, 0, 0.7);
      }

      &.prev {
        left: 20px;
      }

      &.next {
        right: 20px;
      }

      i {
        font-size: 18px;
      }
    }
  }
}

.region-city-under-banner {
  width: 100%;
  margin: 0 0 16px;
  box-sizing: border-box;
}

.main-content {
  background: #fff;
  width: 95%;
  max-width: 1400px;
  margin: 0 auto 20px;

  .page-header {
    margin-bottom: 30px;
    display: flex;
    padding: 30px;

    .page-title {
      font-size: 24px;
      font-weight: 600;
      color: #333;
      margin-left: 30px;
    }
  }

  .content-layout {
    display: flex;
    gap: 30px;
    position: relative;
    align-items: flex-start;

    .sidebar-group {
      display: flex;
      flex-shrink: 0;
      align-items: flex-start;
    }

    .sidebar {
      width: 200px;
      flex-shrink: 0;
      background: #ECF2FF;

      .category-list {
        .category-item {
          display: flex;
          align-items: center;
          padding: 15px 10px;
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            background: #fff;
          }

          &.active {
            background: #fff;
            color: #0E75E5;

            .category-label {
              color: #0E75E5;
            }
          }

          .category-icon-slot {
            width: 20px;
            height: 20px;
            margin-right: 12px;
            flex-shrink: 0;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;

            &.is-empty {
              border-radius: 3px;
              background: rgba(14, 117, 229, 0.08);
              border: 1px dashed rgba(14, 117, 229, 0.2);
            }
          }

          .category-icon {
            width: 20px;
            height: 20px;
            object-fit: contain;
            display: block;
          }

          .category-label {
            font-size: 14px;
            color: #333;
            font-weight: 500;
          }
        }
      }
    }

    .right-content {
      flex: 1;
      padding-right: 20px;

      .search-section {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0;
        margin-bottom: 20px;

        .search-input {
          display: flex;
          align-items: center;
          background: #fff;
          border: 1px solid #f39800;
          border-radius: 10px;
          padding: 0 15px;
          width: 100%;
          border-right: none;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;

          .search-icon {
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }

          input {
            border: none;
            outline: none;
            height: 60px;
            width: 100%;
            font-size: 14px;

            &::placeholder {
              color: #999;
            }
          }
        }

        .search-btn {
          background: #f39800;
          color: #fff;
          border: none;
          width: 160px;
          height: 62px;
          border-radius: 10px;
          font-size: 16px;
          cursor: pointer;
          transition: background 0.3s ease;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;

          &:hover {
            background: #e08a00;
          }
        }
      }

      .recommended-section {
        margin-bottom: 40px;

        .section-title {
          font-size: 18px;
          font-weight: 600;
          color: #333;
          margin-bottom: 15px;
        }

        .recommended-single {
          position: relative;
        }

        .recommended-slide {
          position: relative;
          width: 100%;
          overflow: hidden;
        }

        // 单图模式下的图片自适应，防止超出屏幕
        .recommended-slide {
          cursor: pointer;
          transition: transform 0.3s ease;

          &:hover {
            transform: translateY(-2px);
          }
        }

        .recommended-slide .recommended-image {
          display: block;
          width: 100%;
          max-width: 100%;
          height: 280px;
          object-fit: cover;
          border-radius: 8px;
          margin-bottom: 12px;
          transition: transform 0.3s ease;
        }

        .recommended-slide:hover .recommended-image {
          transform: scale(1.02);
        }

        .recommended-title {
          font-size: 16px;
          font-weight: 600;
          color: #333;
          line-height: 1.5;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-clamp: 2;
          padding: 0 4px;
        }

        .loading-text, .no-data {
          text-align: center;
          color: #999;
          padding: 20px;
          font-size: 14px;
        }

        .recommended-cases-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 20px;
        }

        .recommended-case {
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          }

          .recommended-image {
            width: 100%;
            height: 420px; // 占满推荐区域更高的可视高度
            object-fit: cover;
            border-radius: 8px;
            margin-bottom: 10px;
          }

          .recommended-title {
            font-size: 14px;
            color: #666;
            line-height: 1.4;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            line-clamp: 2;
          }
        }

        // 复用顶部轮播的指示器与箭头样式
        .banner-indicators {
          position: absolute;
          bottom: 12px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 8px;
          z-index: 2;
        }

        .banner-nav {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 40px;
          height: 40px;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border-radius: 50%;
          transition: all 0.3s ease;
          z-index: 2;

          &:hover {
            background: rgba(0, 0, 0, 0.7);
          }

          &.prev {
            left: 12px;
          }

          &.next {
            right: 12px;
          }
        }
      }
    }
  }
}

// 分类下拉选择样式（紧贴左侧 sidebar 右缘，与 sidebar 并排不遮挡）
.category-dropdown {
  position: relative;
  flex-shrink: 0;
  align-self: flex-start;
  background: #fff;
  border: 1px solid #e9ecef;
  border-left: none;
  border-radius: 0 8px 8px 0;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.12);

  .dropdown-content {
    display: flex;
    align-items: flex-start;

    .subcategory-content {
      width: 200px;
      max-height: 400px;
      border-right: 1px solid #e9ecef;
      background: #fff;
      overflow-y: auto;

      // 自定义滚动条样式
      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
      }

      &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;

        &:hover {
          background: #a8a8a8;
        }
      }

      .subcategory-list {
        .subcategory-item {
          padding: 15px 20px;
          cursor: pointer;
          transition: all 0.3s ease;
          border-bottom: 1px solid #f0f0f0;
          font-size: 14px;
          color: #666;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &:hover {
            background: #f0f8ff;
            color: #0f6fe2;
          }

          &.active {
            background: #0f6fe2;
            color: #fff;
          }
        }
      }
    }

    .subsubcategory-content {
      width: 200px;
      max-height: 400px;
      background: #fff;
      overflow-y: auto;

      // 自定义滚动条样式
      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
      }

      &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;

        &:hover {
          background: #a8a8a8;
        }
      }

      .subsubcategory-list {
        .subsubcategory-item {
          padding: 15px 20px;
          cursor: pointer;
          transition: all 0.3s ease;
          border-bottom: 1px solid #f0f0f0;
          font-size: 14px;
          color: #666;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &:hover {
            background: #f0f8ff;
            color: #0f6fe2;
          }

          &.active {
            background: #0f6fe2;
            color: #fff;
          }
        }
      }
    }
  }
}

// 工业建筑案例区域样式
.industrial-cases-section {
  padding: 30px;
  background: #fff;
  margin: 0 auto 20px;
  width: 95%;
  max-width: 1400px;

  .section-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 20px;
  }

  .list-loading,
  .list-empty {
    text-align: center;
    color: #999;
    padding: 60px 20px;
    font-size: 14px;
  }

  .list-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 240px;
  }

  .list-empty-icon {
    width: 64px;
    height: 64px;
    object-fit: contain;
    margin-bottom: 16px;
    opacity: 0.45;
  }

  .list-empty-text {
    font-size: 14px;
    color: #999;
  }

  .industrial-pagination-wrap {
    padding: 20px 0;
  }

  .cases-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;
    align-items: start;

    .case-card {
      cursor: pointer;
      transition: all 0.3s ease;
      width: 100%;
      min-width: 0; // 使内部文本省略在 CSS Grid 下生效

      &:hover {
        transform: translateY(-2px);
      }

      .case-image {
        margin-bottom: 10px;
        width: 100%;
        aspect-ratio: 1;
        overflow: hidden;
        border-radius: 6px;

        .case-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 6px;
        }
      }

      .case-title {
        font-size: 14px;
        color: #666;
        line-height: 1.4;
        text-align: center;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

// 响应式设计
@media (max-width: 1600px) {
  .banner-section {
    height: 280px;
  }

  .industrial-cases-section .cases-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 1366px) {
  .banner-section {
    height: 220px;
  }

  .industrial-cases-section .cases-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 1200px) {
  .banner-section {
    height: 220px;
  }

  .industrial-cases-section {
    .cases-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}

@media (max-width: 768px) {
  .region-city-under-banner {
    width: 100%;
    max-width: none;
    margin: 0 10px 12px;
    padding-left: 5px;
    box-sizing: border-box;
  }

  .banner-section {
    height: 250px;

    .banner-container {
      .banner-nav {
        width: 35px;
        height: 35px;

        &.prev {
          left: 10px;
        }

        &.next {
          right: 10px;
        }

        i {
          font-size: 16px;
        }
      }

      .banner-indicators {
        bottom: 15px;

        .indicator {
          width: 10px;
          height: 10px;
        }
      }
    }
  }

  .costcases-container {
    padding: 0;
  }

  .main-content {
    padding: 20px 15px;
    width: 100%;
    margin: 0 10px;

    .content-layout {
      flex-direction: column;
      gap: 20px;

      .sidebar-group {
        width: 100%;
        flex-direction: column;
      }

      .sidebar {
        width: 100%;

        .category-list {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;

          .category-item {
            flex: 1;
            min-width: 120px;
            justify-content: center;
            margin-bottom: 0;
          }
        }
      }

      .right-content {
        .search-section {
          width: 100%;

          .search-input {
            width: 100%;
          }
        }
      }
    }
  }

  .category-dropdown {
    position: relative;
    left: auto;
    top: auto;
    width: 100%;
    border-left: 1px solid #e9ecef;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }

  .industrial-cases-section {
    padding: 20px 15px;

    .cases-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 15px;
    }
  }
}

@media (max-width: 480px) {
  .banner-section {
    height: 200px;

    .banner-container {
      .banner-nav {
        width: 30px;
        height: 30px;

        &.prev {
          left: 5px;
        }

        &.next {
          right: 5px;
        }

        i {
          font-size: 14px;
        }
      }

      .banner-indicators {
        bottom: 10px;

        .indicator {
          width: 8px;
          height: 8px;
        }
      }
    }
  }

  .main-content {
    padding: 15px 10px;
    margin: 0 5px;

    .content-layout {
      .sidebar {
        .category-list {
          .category-item {
            min-width: 100px;
            padding: 10px 5px;

            .category-label {
              font-size: 12px;
            }
          }
        }
      }
    }
  }

  .industrial-cases-section {
    padding: 15px 10px;

    .cases-grid {
      grid-template-columns: 1fr;
      gap: 10px;
    }
  }
}
</style>
